import { combineReducers } from "@reduxjs/toolkit";
import user from "./user";
import hours from "./hours";
import admin from "./admin";

export default combineReducers({
  user,
  hours,
  admin,
});
